import api from '@/services/api/api';

export const useTestBySlug = (slug) => {
  const testSlug = useQuery(
    ['testSlug', slug],
    async () => {
      const { data } = await api.tests.getTestBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug && !isNaN(Number(slug))),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await testSlug.suspense();
  });

  return {
    testSlug,
  };
};
